import {useLanguage} from '../i18n/LanguageProvider';
import '../styles/about-strip.css';
type IconC=React.ComponentType<{size?:number;strokeWidth?:number}>;
export type StripFact={value:string|number;label:string;Icon:IconC};
/** Below the standard sub-page banner: HUD stat strip (chamfered cells, line icons, scanning light) + ticker. Effects only — no layout borrowed from other pages. */
export function AboutStrip({facts}:{facts:StripFact[]}){
 const {t}=useLanguage();
 const words=['NIBELC','TẬP ĐOÀN','LỊCH SỬ','PHÁT TRIỂN','NHÂN LỰC','ĐÀO TẠO'];
 const tick=Array.from({length:3}).flatMap((_,k)=>words.map(w=><span key={k+w}>{w}<i/></span>));
 return <section className="as-strip container" aria-label={t('Về NIBELC')}>
  <div className="as-ticker" aria-hidden="true"><div>{tick}{tick}</div></div>
  <div className="as-facts">{facts.map(f=><div key={f.label} className="as-cell"><f.Icon size={34} strokeWidth={1.4}/><span><b>{f.value}</b><small>{t(f.label)}</small></span><i className="as-scan" aria-hidden="true"/></div>)}</div>
 </section>;
}
